import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a9eb93b86bf0300142a0339_1788790822830_a51befb5/nexus/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a9eb93b86bf0300142a0339_1788790822830_a51befb5/nexus/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a9eb93b86bf0300142a0339_1788790822830_a51befb5/nexus/src/components/ui/AppLogo.tsx");
